export default __webpack_public_path__ + "static/media/liveInstructor4.af5f9c9f.png";